"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_modal_1 = __importDefault(require("@uswds/uswds/js/usa-modal"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const ButtonGroup_1 = __importDefault(require("./ButtonGroup"));
const ButtonGroupItem_1 = __importDefault(require("./ButtonGroupItem"));
const __1 = require("..");
const ButtonComponent = (0, react_1.forwardRef)(({ accentCool = false, base = false, big = false, children, className, href, inverse = false, onClick, outline = false, secondary = false, unstyled = false, ...props }, ref) => {
    const classes = (0, uswds_react_utils_1.createClassString)('usa-button', accentCool && 'usa-button--accent-cool', base && 'usa-button--base', big && 'usa-button--big', inverse && 'usa-button--inverse', outline && 'usa-button--outline', secondary && 'usa-button--secondary', unstyled && 'usa-button--unstyled', className);
    return href ? ((0, jsx_runtime_1.jsx)(__1.Link, { className: classes, onClick: onClick, ref: ref, ...props, href: href, children: children })) : ((0, jsx_runtime_1.jsx)("button", { className: classes, onClick: (e) => {
            if (onClick)
                onClick(e);
            if (props['data-close-modal'] || props['data-open-modal']) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error improper types from USWDS package
                usa_modal_1.default.toggleModal.bind(e.target)(e);
                e.stopPropagation();
            }
        }, type: "button", ref: ref, ...props, children: children }));
});
const Button = Object.assign(ButtonComponent, { Group: ButtonGroup_1.default, GroupItem: ButtonGroupItem_1.default });
exports.default = Button;
